export default __webpack_public_path__ + "static/media/3-10_icon.13349820.svg";